import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { vatNumberStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsVatNumber";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

vatNumberStyles.wrapper = mergeToNew(vatNumberStyles.wrapper, {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        flex-direction: column;
        padding: 0px;
    `,
});

vatNumberStyles.titleText = mergeToNew(vatNumberStyles.titleText, {
    variant: "h3",
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 16px;
        width: 100%;
    `,
});

vatNumberStyles.vatNumberText = mergeToNew(vatNumberStyles.vatNumberText, {
    css: css`
        padding: 4px;
    `,
});
